// extracted by mini-css-extract-plugin
export default {"block":"FinancialDataDisclaimer_block__4dH3G","inline":"FinancialDataDisclaimer_inline__tecpX"};